import {
  TAB_STATUS_ALL,
  TAB_STATUS_CONS,
  TAB_STATUS_DONE,
  TAB_STATUS_TODO,
} from '../../components/ViewControls/CertsControlTabs/constant';

// Config
export const AXIOS_TIMEOUT = 300000;
export const FORCED_CANCELLATION = 'ERR_CANCELED';
export const FORCED_CANCELLATION_MESSAGE = 'Forced cancellation';
export const DATA_FETCH_ERROR = 'Data Fetch Error';
export const TIMEOUT_CANCELLATION = 'ECONNABORTED';
export const axiosTimeoutConfig = { timeout: AXIOS_TIMEOUT };
export const tabMapping = {
  [TAB_STATUS_TODO]: 'todo',
  [TAB_STATUS_DONE]: 'done',
  [TAB_STATUS_ALL]: 'all',
  [TAB_STATUS_CONS]: 'consulted',
};

// Global
export const UPDATE_SCREEN_SIZE = 'UPDATE_SCREEN_SIZE';
export const SET_TOUCH_DEVICE_STATUS = 'CERTDETAILS/SET_TOUCH_DEVICE_STATUS';
export const SET_CERT_DETAILS_LISTS = 'CERTDETAILS/SET_CERT_DETAILS_LISTS';
export const SET_CERT_ITEMS_OFFSET_COUNT =
  'CERTDETAILS/SET_CERT_ITEMS_OFFSET_COUNT';
export const SET_CERTS_TIME_ZONE = 'CERTDETAILS/SET_CERTS_TIME_ZONE';
export const SET_CERT_DETAILS_CERT_KEY =
  'CERTDETAILS/SET_CERT_DETAILS_CERT_KEY';
export const SET_CERT_DETAILS_VIEW_COLUMNS_LIST =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_COLUMNS_LIST';
export const SET_CERT_DETAILS_VIEW_ROWS_LIST =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_ROWS_LIST';
export const SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY';
export const SET_CERT_DETAILS_COLUMN_PICKER_LIST =
  'CERTDETAILS/SET_CERT_DETAILS_COLUMN_PICKER_LIST';
export const SET_CERT_DETAILS_FLATTENED_COLUMN_PICKER_LIST =
  'CERTDETAILS/SET_CERT_DETAILS_FLATTENED_COLUMN_PICKER_LIST';
export const CERT_DETAILS_COL_PICKER_LOADING =
  'CERTDETAILS/CERT_DETAILS_COL_PICKER_LOADING';
export const SET_CERT_DETAILS_VIEW_CERT_NAME =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_NAME';
export const SET_CERT_DETAILS_VIEW_CERT_AUDITOR =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_AUDITOR';
export const SET_CERT_OBJECT_FOR_REDIRECT =
  'CERTDETAILS/SET_CERT_OBJECT_FOR_REDIRECT';
export const SET_CERT_GLOBAL_DATE_FORMAT =
  'CERTDETAILS/SET_CERT_GLOBAL_DATE_FORMAT';

// Core
export const SET_CERT_DETAILS_CAMPAIGN_KEY =
  'CERTDETAILS/SET_CERT_DETAILS_CAMPAIGN_KEY';
export const SET_CERT_DETAILS_LISTS_COUNT =
  'CERTDETAILS/SET_CERT_DETAILS_LISTS_COUNT';
export const CERT_DETAILS_LISTS_LOADING =
  'CERTDETAILS/CERT_DETAILS_LISTS_LOADING';
export const CERT_DETAILS_REFRESH_SUCCESS =
  'CERTDETAILS/CERT_DETAILS_REFRESH_SUCCESS';
export const CERT_DETAILS_LISTS_ERROR = 'CERTDETAILS/CERT_DETAILS_LISTS_ERROR';
export const CERT_DETAILS_TRIGGER_FROM_SEARCH =
  'CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SEARCH';
export const CERT_DETAILS_VIEW_LOADING =
  'CERTDETAILS/CERT_DETAILS_VIEW_LOADING';
export const CERTS_RECORDS_COUNT = 'CERTDETAILS/CERTS_RECORDS_COUNT';
export const CERT_DETAILS_COLUMNS_TO_SHOW =
  'CERTDETAILS/CERT_DETAILS_COLUMNS_TO_SHOW';
export const CERT_DETAILS_VIEW_API_ERROR =
  'CERTDETAILS/CERT_DETAILS_VIEW_API_ERROR';
export const CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR =
  'CERTDETAILS/CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR';
export const SET_CERT_TRUST_SCORE_FLAG =
  'CERTDETAILS/SET_CERT_TRUST_SCORE_FLAG';

// View controls
export const CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER =
  'CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER';
export const SET_CERT_FILTERS = 'CERTDETAILS/SET_CERT_FILTERS';
export const SET_GROUP_BY_OPTIONS = 'CERTDETAILS/SET_GROUP_BY_OPTIONS';
export const SET_ROWS_FILTERS = 'CERTDETAILS/SET_ROWS_FILTERS';
export const SET_APPLIED_ROW_FILTERS = 'CERTDETAILS/SET_APPLIED_ROW_FILTERS';
export const SET_COLS_FILTERS = 'CERTDETAILS/SET_COLS_FILTERS';
export const ACTIVE_ADVANCED_FILTERS = 'CERTDETAILS/ACTIVE_ADVANCED_FILTERS';
export const SET_CERTS_ACTIONS_FILTER = 'CERTDETAILS/SET_CERTS_ACTIONS_FILTER';
export const SET_CLEAR_FILTERS_BTN_STATUS =
  'CERTDETAILS/SET_CLEAR_FILTERS_BTN_STATUS';
export const SET_CLEAR_SEARCH_BTN_STATUS =
  'CERTDETAILS/SET_CLEAR_SEARCH_BTN_STATUS';
export const SET_CLEAR_HIERARCHY_BTN_STATUS =
  'CERTDETAILS/SET_CLEAR_HIERARCHY_BTN_STATUS';
export const SET_SMART_FILTER_ID = 'CERTDETAILS/SET_SMART_FILTER_ID';

// SidePanels
export const CERT_DETAILS_SIDE_PANEL_VISIBLE =
  'CERTDETAILS/CERT_DETAILS_SIDE_PANEL_VISIBLE';
export const SET_SIDE_PANEL_BODY_LOADING =
  'CERTDETAILS/SET_SIDE_PANEL_BODY_LOADING';
export const SET_SIDE_PANEL_ERROR = 'CERTDETAILS/SET_SIDE_PANEL_ERROR';
export const SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS =
  'CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS';
export const SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS =
  'CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS';
export const SET_SIDE_PANEL_SOD_ENTITLEMENTS =
  'CERTDETAILS/SET_SIDE_PANEL_SOD_ENTITLEMENTS';
export const SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS =
  'CERTDETAILS/SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS';
export const SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS =
  'CERTDETAILS/SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS';
export const SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS =
  'CERTDETAILS/SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS';
export const SET_SIDE_PANEL_SUMMARY_ACCOUNTS =
  'CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ACCOUNTS';
export const SET_SIDE_PANEL_HISTORY2_ACCOUNTS =
  'CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ACCOUNTS';
export const SET_SIDE_PANEL_SUMMARY_USERS =
  'CERTDETAILS/SET_SIDE_PANEL_SUMMARY_USERS';
export const SET_SIDE_PANEL_HISTORY2_USERS =
  'CERTDETAILS/SET_SIDE_PANEL_HISTORY2_USERS';
export const SET_SIDE_PANEL_SUMMARY_ROLES =
  'CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ROLES';
export const SET_SIDE_PANEL_HISTORY2_ROLES =
  'CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ROLES';
export const SET_SIDE_PANEL_ENTITLEMENT_ROLES =
  'CERTDETAILS/SET_SIDE_PANEL_ENTITLEMENT_ROLES';
export const SET_SIDE_PANEL_CHILDREN_ROLES =
  'CERTDETAILS/SET_SIDE_PANEL_CHILDREN_ROLES';
export const SIDE_PANEL_INITIAL_LOAD = 'CERTDETAILS/SIDE_PANEL_INITIAL_LOAD';
export const SIDE_PANEL_LOAD_MORE_BUTTON =
  'CERTDETAILS/SIDE_PANEL_LOAD_MORE_FLAG';
export const SET_PREDEFINED_COMMENTS = 'CERTDETAILS/SET_PREDEFINED_COMMENTS';

// Access request history
export const SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL =
  'CERTDETAILS/SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL';
export const SET_LOADING_FOR_ARS_MODAL =
  'CERTDETAILS/SET_LOADING_FOR_ARS_MODAL';
export const SET_ERROR_FOR_ARS_MODAL = 'CERTDETAILS/SET_ERROR_FOR_ARS_MODAL';
export const SET_DATA_FOR_ARS_MODAL = 'CERTDETAILS/SET_DATA_FOR_ARS_MODAL';

// Bulk actions
export const SET_SHOW_BULK_SELECT_CHEKBOX =
  'CERTDETAILS/SET_SHOW_BULK_SELECT_CHEKBOX';
export const SET_SHOW_BULK_CHECKBOX = 'CERTDETAILS/SET_SHOW_BULK_CHECKBOX';
export const SET_CHECK_FOR_BULK_CHEKBOX =
  'CERTDETAILS/SET_CHECK_FOR_BULK_CHEKBOX';
export const SET_INDETERMINATE_FOR_BULK_CHEKBOX =
  'CERTDETAILS/SET_INDETERMINATE_FOR_BULK_CHEKBOX';
export const SET_BULK_FOOTER_SHOW = 'CERTDETAILS/SET_BULK_FOOTER_SHOW';
export const SET_BULK_FOOTER_DATA = 'CERTDETAILS/SET_BULK_FOOTER_DATA';
export const SET_DISABLE_FOR_BULK_SELECT_ALL =
  'CERTDETAILS/SET_DISABLE_FOR_BULK_SELECT_ALL';
export const SET_SUBMIT_FOR_BULK_SELECT_ALL =
  'CERTDETAILS/SET_SUBMIT_FOR_BULK_SELECT_ALL';
export const SET_ATLEAST_ONE_IS_SELECTED =
  'CERTDETAILS/SET_ATLEAST_ONE_IS_SELECTED';
export const SET_BULK_ACTIONS_ALERT = 'CERTDETAILS/SET_BULK_ACTIONS_ALERT';
export const SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL =
  'CERTDETAILS/SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL';
export const SET_BULK_ACTIONS_ISSUBMITTING =
  'CERTDETAILS/SET_BULK_ACTIONS_ISSUBMITTING';
export const IS_BULK_ACTIONS_COMPLETED =
  'CERTDETAILS/IS_BULK_ACTIONS_COMPLETED';

// Review and Submit
export const REVIEW_AND_SUBMIT_LOADING =
  'CERTDETAILS/REVIEW_AND_SUBMIT_LOADING';
export const REVIEW_AND_SUBMIT_ERROR = 'CERTDETAILS/REVIEW_AND_SUBMIT_ERROR';
export const REVIEW_AND_SUBMIT_CONFIG = 'CERTDETAILS/REVIEW_AND_SUBMIT_CONFIG';
export const REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS =
  'CERTDETAILS/REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS';
export const REVIEW_AND_SUBMIT_STEP_1_DATA =
  'CERTDETAILS/REVIEW_AND_SUBMIT_STEP_1_DATA';
export const SET_REVIEW_AND_SUBMIT_BTN_DISPLAY =
  'CERTDETAILS/SET_REVIEW_AND_SUBMIT_BTN_DISPLAY';

// Tabs
export const SET_CERT_TABS = 'CERTDETAILS/SET_CERT_TABS';
export const SET_TABHIGHLIGHT_NAME = 'CERTDETAILS/SET_TABHIGHLIGHT_NAME';
export const SET_TAB_COUNTS_DISABLED = 'CERTDETAILS/POST_TAB_COUNTS_DISABLED';
export const SET_TAB_COUNTS_ERROR = 'CERTDETAILS/POST_TAB_COUNTS_ERROR';
export const SET_TAB_COUNTS_LOADING = 'CERTDETAILS/POST_TAB_COUNTS_LOADING';
export const SET_TAB_COUNTS_SUCCESS = 'CERTDETAILS/POST_TAB_COUNTS_SUCCESS';

// Popover progress bar
export const SET_PROGRESS_BREAKDOWN_DETAILS =
  'CERTDETAILS/SET_PROGRESS_BREAKDOWN_DETAILS';
export const SET_PROGRESS_BREAKDOWN_DETAILS_LOADING =
  'CERTDETAILS/SET_PROGRESS_BREAKDOWN_DETAILS_LOADING';
export const SET_PROGRESS_BREAKDOWN_DETAILS_ERROR =
  'CERTDETAILS/SET_PROGRESS_BREAKDOWN_DETAILS_ERROR';
export const SET_DYNAMIC_SORT_FILTER_DETAILS =
  'CERTDETAILS/SET_DYNAMIC_SORT_FILTER_DETAILS';
export const RESET_DYNAMIC_SORT_FILTER_DETAILS =
  'CERTDETAILS/RESET_DYNAMIC_SORT_FILTER_DETAILS';
export const SET_ENABLE_INDIVIDUAL_COMMENTS =
  'CERTDETAILS/SET_ENABLE_INDIVIDUAL_COMMENTS';

// Action Buttons
export const SET_ACTION_COUNT_CHECK = 'CERTDETAILS/SET_ACTION_COUNT_CHECK';
export const SET_ACTION_LOADING = 'CERTDETAILS/SET_ACTION_LOADING';
export const SET_ACTION_SUCCESS = 'CERTDETAILS/ET_ACTION_SUCCESS';
export const SET_ACTION_RESET = 'CERTDETAILS/SET_ACTION_RESET';
export const SET_ACTION_MODAL_OPEN = 'CERTDETAILS/SET_ACTION_MODAL_OPEN';
export const SET_ACTION_ERROR = 'CERTDETAILS/SET_ACTION_ERROR';
export const SET_ACTION_SUCCESS_ALERT_MESSAGE =
  'CERTDETAILS/SET_SUCCESS_ALERT_MESSAGE';
// Terminate User
export const SET_CERT_DETAILS_TERMINATE_COMMENTS =
  'CERTDETAILS/SET_CERT_DETAILS_TERMINATE_COMMENTS';
export const SET_CERT_DETAILS_TERMINATE_CONFIG_MAP =
  'CERTDETAILS/SET_CERT_DETAILS_TERMINATE_CONFIG_MAP';
export const SET_ACTION_SUCCESS_TERMINATE =
  'CERTDETAILS/SET_ACTION_SUCCESS_TERMINATE';
export const SET_CERT_DETAILS_VIEW_CERT_START_DATE =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_START_DATE';
export const SET_CERT_DETAILS_VIEW_CERT_END_DATE =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_END_DATE';
export const SET_CERT_DETAILS_VIEW_CERT_AUTO_REVOKE_LIST =
  'CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_AUTO_REVOKE_LIST';

// Store consult action assignee list
export const SET_CONSULT_ACTION_ASSIGNEE_LIST =
  'CERTDETAILS/SET_CONSULT_ACTION_ASSIGNEE_LIST';
export const SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING =
  'CERTDETAILS/SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING';
export const SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR =
  'CERTDETAILS/SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR';
export const SET_REASSIGN_CONFIG = 'CERTDETAILS/SET_REASSIGN_CONFIG';
export const SET_IS_REASSIGN_WARN_MSG_OPENED =
  'CERTDETAILS/SET_IS_REASSIGN_WARN_MSG_OPENED';
export const SET_IS_REASSIGN_POPOVER_MSG =
  'CERTDETAILS/SET_IS_REASSIGN_POPOVER_MSG';
// Child before Parent
export const SET_VERIFY_PARENT_LOADING =
  'CERTDETAILS/SET_VERIFY_PARENT_LOADING';
export const SET_VERIFY_PARENT_MAP = 'CERTDETAILS/SET_VERIFY_PARENT_MAP';
export const SET_VERIFY_PARENT_ERROR = 'CERTDETAILS/SET_VERIFY_PARENT_ERROR';

// Savi Companion Types
export const SET_IS_SAVI_FILTER_APPLIED =
  'CERTDETAILS/SET_IS_SAVI_FILTER_APPLIED';
export const GET_SAVI_COMPANION_STATUS_LOAD =
  'CERTDETAILS/GET_SAVI_COMPANION_STATUS_LOAD';
export const GET_SAVI_COMPANION_STATUS_SUCCESS =
  'CERTDETAILS/GET_SAVI_COMPANION_STATUS_SUCCESS';
export const GET_SAVI_COMPANION_STATUS_FAILURE =
  'CERTDETAILS/GET_SAVI_COMPANION_STATUS_FAILURE';
export const APPLY_SAVI_COMPANION_ACTIONS_LOAD =
  'CERTDETAILS/APPLY_SAVI_COMPANION_ACTIONS_LOAD';
export const APPLY_SAVI_COMPANION_ACTIONS_SUCCESS =
  'CERTDETAILS/APPLY_SAVI_COMPANION_ACTIONS_SUCCESS';
export const APPLY_SAVI_COMPANION_ACTIONS_FAILURE =
  'CERTDETAILS/APPLY_SAVI_COMPANION_ACTIONS_FAILURE';
export const SET_IS_SAVI_COMPANION_ENABLED =
  'CERTDETAILS/SET_IS_SAVI_COMPANION_ENABLED';
export const SET_IS_CERTIFICATE_ACTIONABLE =
  'CERTDETAILS/SET_IS_CERTIFICATE_ACTIONABLE';
export const CERT_DETAILS_TRIGGER_FROM_SAVI_APPLY_ACTIONS =
  'CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SAVI_APPLY_ACTIONS';
export const CLEAR_SAVI_ACTIONS_FILTER =
  'CERTDETAILS/CLEAR_SAVI_ACTIONS_FILTER';
export const APPLIED_SAVI_ACITONS_FILTER =
  'CERTDETAILS/APPLIED_SAVI_ACITONS_FILTER';

// Smart Filters
export const SET_IS_SMART_FILTER_APPLIED =
  'CERTDETAILS/SET_IS_SMART_FILTER_APPLIED';
export const FETCH_SMART_FILTERS_META = 'CERTDETAILS/FETCH_SMART_FILTERS_META';
export const FETCH_SMART_FILTERS_META_SUCCESS =
  'CERTDETAILS/FETCH_SMART_FILTERS_META_SUCCESS';
export const FETCH_SMART_FILTERS_META_FAILURE =
  'CERTDETAILS/FETCH_SMART_FILTERS_META_FAILURE';
export const CLEAR_SMART_FILTERS = 'CERTDETAILS/CLEAR_SMART_FILTERS';
export const CLEAR_ALL_FILTERS = 'CERTDETAILS/CLEAR_ALL_FILTERS';
export const APPLIED_SAVI_SMART_FILTER =
  'CERTDETAILS/APPLIED_SAVI_SMART_FILTER';

// Personalization
export const SET_PERSONALIZATION_STATUS = 'SET_PERSONALIZATION_STATUS';
export const SET_PERSONALIZATION = 'SET_PERSONALIZATION';
export const CREATE_PERSONALIZATION = 'CREATE_PERSONALIZATION';
export const UPDATE_PERSONALIZATION = 'UPDATE_PERSONALIZATION';
export const UPDATE_PERSONALIZATION_API_STATUS =
  'UPDATE_PERSONALIZATION_API_STATUS';
export const SET_ALL_CAMPAIGN_PERSONALIZATION_DATA =
  'CERTDETAILS/SET_ALL_CAMPAIGN_PERSONALIZATION_DATA';
export const PERSONALIZATION_VIEW_OPTION = 'PERSONALIZATION_VIEW_OPTION';
export const CLEAR_CURRENT_PERSONALIZATION = 'CLEAR_CURRENT_PERSONALIZATION';
export const PERSONALIZATION_SET_DEFAULT_VIEW =
  'CERTDETAILS/PERSONALIZATION_SET_DEFAULT_VIEW';
export const PERSONALIZATION_ALL = 'PERSONALIZATION_ALL';

// Export
export const CERTS_EXPORT_STATUS = 'CERTS_EXPORT_STATUS';
export const CERTS_EXPORT_APPLY_FILTER = 'CERTS_EXPORT_APPLY_FILTER';
export const CERTS_EXPORT_COLUMNS_TO_EXPORT = 'CERTS_EXPORT_COLUMNS_TO_EXPORT';
export const GET_CERTS_DETAILS_FOR_EXPORT = 'GET_CERTS_DETAILS_FOR_EXPORT';
export const SET_CERTS_EXPORT_IS_LOADING = 'SET_CERTS_EXPORT_IS_LOADING';
